import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { BottomNav } from '../components/bottom-nav';
import { KpiBar } from '../components/kpi-bar';
import { SidebarNav } from '../components/sidebar-nav';
import { useMediaQuery } from '../hooks/use-media-query';
import { sessionQuery } from '../lib/queries';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context }) => {
    try {
      const session = await context.queryClient.ensureQueryData(sessionQuery);
      return { session };
    } catch {
      throw redirect({ to: '/login' });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const { session } = Route.useRouteContext();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  if (isDesktop) {
    return (
      <div className="flex h-screen bg-ndd-950 text-white">
        <SidebarNav role={session.role} />
        <div className="flex flex-1 flex-col overflow-hidden">
          <KpiBar />
          <main className="flex-1 overflow-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    );
  }

  return (
    <div className="pb-16">
      <Outlet />
      <BottomNav role={session.role} />
    </div>
  );
}
